/* eslint-disable import/prefer-default-export, quote-props, quotes, comma-dangle */
import _ from 'lodash';
import {
	SET_ALL_PETS,
	BASE_COLLECTED_PET,
	PETS,
} from '../constants';

import getNewPets from '../selectors/getNewPets';

const basePet = {
	"kind": "chromewebstore#inAppProduct",
	"sku": "tabby_pet",
	"item_id": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
	"type": "inapp",
	"state": "ACTIVE",
	"prices": [
		{
			"valueMicros": "1000000",
			"currencyCode": "USD",
			"regionCode": "US"
		}
	],
};

export function setAllPets(allPets) {
	return {
		type: SET_ALL_PETS,
		payload: {
			allPets,
		},
	};
}

export function setAllPetsAsync(skuDetailsResponse, purchasesResponse, dispatch, getState) {
	const inAppProducts = _.get(skuDetailsResponse, 'response.details.inAppProducts', []);
	const successfulPurchases = _.filter(_.get(purchasesResponse, 'response.details', []), purchase => purchase.state === 'ACTIVE');
	let petsForApp = [];

	console.log('setAllPetsAsync -- ', [skuDetailsResponse, purchasesResponse]);

	if (_.isEmpty(inAppProducts) && _.isEmpty(successfulPurchases)) {
		petsForApp = _.chain(PETS)
			.map((pet) => {
				// We add tabby cat at the end.
				if (pet.sku === 'cat_tabbycat') {
					return undefined;
				}

				const petInCodeBase = true;
				const isCollected = !!petInCodeBase && !!_.find(successfulPurchases, ['sku', pet.sku]);
				const isComingSoon = pet.state === 'INACTIVE' || !petInCodeBase;

				// Newness
				const thisPetFromLastTime = _.find(getState().allPets, { sku: pet.sku, isComingSoon: false });
				const isNewThisTime = !thisPetFromLastTime && !isCollected && !isComingSoon; // It wasn't here last time, it's not collected or coming soon.
				const isNewFromLastTime = _.get(thisPetFromLastTime, 'isNew') && !isCollected; // It was new last time and hasn't been collected since then.
				const isNew = isNewThisTime || isNewFromLastTime;

				// Build a fake pet
				return {
					...basePet,
					sku: pet.sku,
					petType: pet,
					isCollected,
					isComingSoon,
					isNew,
					"localeData": [
						{
							"title": pet.displayName,
							"description": "",
							"languageCode": "en-US",
						},
					],
				};
			})
			.filter(pet => pet !== undefined)
			.value();

	} else {
		petsForApp = _.map(inAppProducts, (pet) => {
			const petInCodeBase = _.find(PETS, ['sku', pet.sku]);
			const isCollected = !!petInCodeBase && !!_.find(successfulPurchases, ['sku', pet.sku]);
			const isComingSoon = pet.state === 'INACTIVE' || !petInCodeBase;

			// Newness
			const thisPetFromLastTime = _.find(getState().allPets, { sku: pet.sku, isComingSoon: false });
			const isNewThisTime = !thisPetFromLastTime && !isCollected && !isComingSoon; // It wasn't here last time, it's not collected or coming soon.
			const isNewFromLastTime = _.get(thisPetFromLastTime, 'isNew') && !isCollected; // It was new last time and hasn't been collected since then.
			const isNew = isNewThisTime || isNewFromLastTime;

			return {
				...pet,
				petType: petInCodeBase,
				isCollected,
				isComingSoon,
				isNew,
			};
		});
	}

	petsForApp.unshift(BASE_COLLECTED_PET);

	dispatch(setAllPets(petsForApp));
}

export function removeNewnessFromPets() {
	return (dispatch, getState) => {
		let petsWithoutNewness = [];

		if (_.isEmpty(getNewPets(getState().allPets))) {
			// Don't do anything if there aren't any new pets to clear.
			return;
		}

		petsWithoutNewness = _.map(getState().allPets, pet => ({
			...pet,
			isNew: false,
		}));

		dispatch(setAllPets(petsWithoutNewness));
	};
}

export function setPetToCollected(sku, isCollected) {
	return (dispatch, getState) => {
		const newPets = _.map(getState().allPets, (pet) => {
			if (pet.sku !== sku) {
				return pet;
			}
			return {
				...pet,
				isCollected,
			};
		});

		dispatch(setAllPets(newPets));
	};
}



// WEBPACK FOOTER //
// ./src/actions/allPets.js